import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import ExpenseCategoryService from "../../../services/expenses/expenseCategoryServices";

const AddExpenseCategory = () => {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm();

  const [category_name, setCategory_name] = useState("");
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);

  const handelClick = () => navigate("/expense-categories");

  const handleRegister = () => {
    if (!category_name) {
      toast.error("Category name is required");
      return;
    }

    setLoading(true);
    setDisable(true);

    ExpenseCategoryService.createCategory({
      category_name: category_name,
    })
      .then(() => {
        toast.success("Expense Category Added Successfully");
        setTimeout(() => navigate("/expense-categories"), 1000);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to add category");
        setLoading(false);
        setDisable(false);
      });
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <h5>{t("Create New Expense Category")}</h5>
        <h6>
          <Link to="/expense-categories" className="tc">
            {t("Expense Categories")}
          </Link>{" "}
          / <span>{t("New Category")}</span>
        </h6>

        <form onSubmit={handleSubmit(handleRegister)}>
          <div className="form-group">
            <label className="required">{t("Category Name")}</label>
            <input
              type="text"
              className="form-control"
              {...register("categoryname", {
                onChange: (e) => setCategory_name(e.target.value),
                required: true,
              })}
            />
            {errors.categoryname && (
              <div className="invalid-feedback d-block">
                Category Name is required
              </div>
            )}
          </div>

          <div className="text-left py-3">
            <button
              type="button"
              onClick={handelClick}
              className="btn btn-secondary"
            >
              {t("Cancel")}
            </button>
            &nbsp;&nbsp;
            <button
              type="submit"
              className="btn btn-primary"
              disabled={disable}
            >
              {loading ? <ButtonLoading /> : t("Save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddExpenseCategory;
